<ng2-smart-table *ngIf="settings" (userRowSelect)="rowSelect($event)" [settings]="settings" [source]="data"></ng2-smart-table>
